import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import CustomersManager from '@/components/customers/CustomersManager';

export default function AdminCustomers() {
  return (
    <AppShell nav={adminNav} title="Daftar Customer">
      <CustomersManager />
    </AppShell>
  );
}
